import { CountrySelect } from '@/views/screens/common';
import { Col, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormInput from '../../../../components/Inputs/FormInput';
import PortNameSelector from '../../../../components/Selectors/PortNameSelector';

const ShiperConsigneeQuoteSearch = ({ form, type }) => {
  const roleType = type === 1 ? { short: 'O', full: 'shipper' } : { short: 'C', full: 'consignee' };

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handlePortCode = ({ portCode }) => {
    form.setFieldsValue({ [`${roleType.full}Port`]: portCode });
  };

  return (
    <Row className="pt-10">
      <Col sm={24}>
        <CountrySelect name={`${roleType.full}Country`} />
      </Col>
      <Col sm={24} className="mb-16">
        <FormInput name={`${roleType.full}City`} quoteType="search" label="City" placeholder="Select City" editMode />
      </Col>
      <Col sm={24} className="mb-16">
        <PortNameSelector
          label={t('translation:rateShop.rateShop.port')}
          name={`${roleType.full}Port`}
          editMode
          handlePortDetails={handlePortCode}
          labelForTestId={`${roleType.full}-port`}
        />
      </Col>
    </Row>
  );
};
export default ShiperConsigneeQuoteSearch;
